import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';


import { AppComponent } from './app.component';
import { RootsharedModule } from './shared/rootshared.module';
// Routing Module
import { AppRoutingModule } from './app.routing';

// Layouts
import { SimpleLayoutComponent } from './layouts/simple-layout.component';

@NgModule({
  imports: [
    AppRoutingModule,
    RootsharedModule,
  ],
  declarations: [
    AppComponent,
    SimpleLayoutComponent,
  ],
  providers: [
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts